<script setup>
import { useElementSize } from '@vueuse/core';
import { computed, onMounted, ref, nextTick } from 'vue';
import HoverCard from '../table/HoverCard.vue';
import PickupCard from '../table/PickupCard.vue';
import ProofUpload from '../table/ProofUpload.vue';
import TmsTable from '../table/TmsTable.vue';

const container = ref();
const { width, height } = useElementSize(container);

const columnsType = [
  {
    name: 'siNo',
    field: 'siNo',
    label: 'SI. No.',
  },
  {
    name: 'businessNature',
    label: 'Nature of Business',
  },
  {
    name: 'registrationNo',
    label: 'Registration No',
  },
  {
    name: 'vendorId',
    label: 'Vendor ID',
  },
  {
    name: 'businessName',
    label: 'Business Name',
  },
  {
    name: 'phoneNo',
    label: 'Phone No',
  },
  {
    name: 'bankName',
    label: 'Bank Name',
  },
  {
    name: 'accountNo',
    label: 'Account No',
  },
  {
    name: 'financeDetails',
    label: 'Finance Details',
  },
  {
    name: 'bankDetails',
    label: 'Bank Details',
  },
  {
    name: 'attachment',
    label: 'Attachment',
  },
  { name: 'vendorStatus', label: 'Status' },
];

const columns = computed(() => {
  let arr = [];
  columnsType.forEach((e) => {
    e.align = 'left';
    e.field = e.name;
    arr.push(e);
  });
  return arr;
});

const seed = [
  {
    siNo: 60,
    businessNature: 'Transportation',
    registrationNo: 'KT0566956-A',
    vendorId: 'VN0LNH6AN1',
    businessName: 'Bungaraya Biz Resources',
    phoneNo: '60146693018',
    bankName: 'PUBLIC BANK BERHAD',
    accountNo: '562115503000',
    financeDetails: { name: null, email: null, contactNo: null },
    bankDetails: {
      bankName: null,
      branchName: null,
      accountNo: null,
      acountName: null,
      swiftCode: null,
    },
    attachment: null,
    vendorStatus: 'on',
  },
];

let data = [];
for (let i = 0; i < 1000; i++) {
  data = data.concat(seed.slice(0).map((r) => ({ ...r })));
}
data.forEach((row, index) => {
  row.index = index;
});
</script>

<template>
  <TmsTable :data="data" :selected="$attrs.selected" :columns="columns" />
</template>
